module.exports = __webpack_public_path__ + "img/gobuy.ebbb8b56.png";